// Apolo IDE — StreamingMessage (live cursor while SSE deltas arrive).
//
// Sprint v6 B2: renders ThinkingBlock above the streamed text whenever
// the server emits thinking deltas (Anthropic extended thinking).
// Sprint B2 (chat refresh): alinhado ao layout de turno do ConversationFeed —
// avatar + label + corpo indentado, com cursor de digitação suave.

import { Bot, Loader2 } from 'lucide-react';
import ThinkingBlock from './chat/ThinkingBlock.jsx';

export default function StreamingMessage({ text, thinking }) {
  if (!text && !thinking) return null;
  const hasThinking = typeof thinking === 'string' && thinking.length > 0;
  const hasText = typeof text === 'string' && text.length > 0;
  return (
    <article
      role="status"
      aria-live="polite"
      aria-relevant="additions text"
      className="flex flex-col gap-1.5 px-1"
    >
      <div className="flex items-center gap-2">
        <span aria-hidden="true" className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-apolo-accent/10">
          <Bot size={13} className="text-apolo-accent" aria-hidden="true" />
        </span>
        <span className="text-[12px] font-semibold text-apolo-accent">Agente</span>
        <span className="inline-flex items-center gap-1 text-[11px] text-apolo-textTertiary">
          <Loader2 size={10} className="animate-spin" aria-hidden="true" />
          {hasText ? 'digitando…' : hasThinking ? 'pensando…' : 'iniciando…'}
        </span>
      </div>
      <div className="flex flex-col gap-1.5 pl-8">
        {hasText && (
          <div className="whitespace-pre-wrap text-sm leading-relaxed text-apolo-textPrimary">
            {text}
            <span aria-hidden="true" className="ml-0.5 inline-block h-3.5 w-[3px] translate-y-[2px] animate-pulse rounded-sm bg-apolo-accent" />
          </div>
        )}
        {/* Pensamento da LLM: colapsado numa frase + mark do Apolo animado,
            pequeno e ABAIXO do texto (canto esquerdo). */}
        {hasThinking && <ThinkingBlock content={thinking} finished={false} />}
      </div>
    </article>
  );
}
